// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo img {
    margin: 10px;
    width: 60px;
}
.example-container {
    display: flex;
    flex-direction: column;
    max-height: 500px;
    background: white;
    min-width: 300px;
}

.example-header {
    min-height: 64px;
    display: flex;
    align-items: center;
    padding-left: 24px;
    font-size: 20px;
}

.mat-table {
    overflow: auto;
}
.preview-container {
    background-color: white;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    overflow: auto;
    margin-bottom: 5px;
}
.preview-header {
    height: 60px;
    padding: 0 20px 0 10px;
    width: 100%;
}
.preview-header .back-button {
    background: transparent;
    border: none;
    color: #d0d4d9;
    cursor: pointer;
    outline: none;
    width: 32px;
    height: 32px;
}
.doc-title {
    margin: 0 15px 0 5px;
}
.doc-title h1 {
    color: #fff;
    font-size: 16px;
    font-weight: normal;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.doc-title-modified {
    color: #d0d4d9;
    font-size: 12px;
    margin-top: 3px;
}

.file-action {
    justify-content: flex-end;
   margin-top: 25px;
}
.file-action button + button {
    margin-left: 1em;
}
.file-action button.mat-button, .file-action button.mat-raised-button {
    line-height: 28px;
    min-width: 80px;
    padding: 0 12px;
    background-color: lavender;
}
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
    /*white-space: nowrap;*/
   word-wrap: break-word;
   max-width: 200px;
}

tr:nth-child(1) {
    background-color: #4b5049;
    /*background-color: rgba(0, 188, 212, 0.7);*/
    color: white;
}
th {
    text-align: center;
}
.mat-raised-button.mat-primary, .mat-fab.mat-primary, .mat-mini-fab.mat-primary, .mat-raised-button.mat-warn{
    /*background-color: rgba(0, 101, 201, 0.89);*/
    margin-top: 17px;
    min-width: 0px;
}
.mat-select {
    margin-left: 15px;
}
.header_report {
    width: 90%;
    /*border: 1px solid #ddd;*/
    border: 1px solid white;
    background-color: white;
    padding: 20px;
    margin: 0 auto;
}
.filter {
    margin: 70px 0px;
}
.filter-title {
    /*background: #53b3ff;*/
    /*padding: 7px 19px 7px;*/
    padding: 0px 19px 0px;
    color: #fff;
    /*font-weight:bold;*/
    text-transform: uppercase;
    width: 90%;
    text-align: left;
    display: flex;
}
.filter-body {
    border: 1px solid #00bcd4;
    padding: 20px;
    width: 90%;
}
.filter-menu {
    display: flex;
    justify-content: center;
}
#filter-year {
    margin-left: 50px;
}
.header_report-title {
    /*font-weight: bold;*/
    font-weight: 500;
    text-align: center;
}
td:nth-child(5) {
    text-align: left;
}
td:nth-child(0), td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(6) {
    text-align: center;
}
td:nth-child(7), td:nth-child(8), td:nth-child(9) {
    text-align: right;
}
.minimize {
    cursor: pointer;
}
.filter-title p {
    flex: 1;
}
.filter-title i {
    margin-top: 15px;
    font-size: 14px;
    cursor: pointer;
}
.mat-dialog-content {
    padding: 0px;
}
#report-zone {
    margin-top: 40px;
}
.page-notfound-icon {
    opacity: .7;
    width: 300px;
    height: 300px;
    margin: auto;
}
.page-notfound {
    text-align: center;
    padding: 10em;
}
.page-notfound h1 {
    font-weight: lighter;
    margin: 1em;
}
.pagination {
    display: inline-block;
}

.pagination a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    border: 1px solid #ddd;
}

.pagination a.active {
    background-color: #53b3ff;
    color: white;
    border-radius: 5px;
    border: 1px solid #53b3ff;
}

.pagination a:hover:not(.active) {
    background-color: #ddd;
    border-radius: 5px;
}
.div-pagination {
    /*margin: 25px 25px;*/
    /*margin: 25px 100px 25px 25px;*/
    margin: 25px 0px;
}
.page {
    cursor: pointer;
}
.size {
    min-height: 250px;
    align-items: start;
}
h3 {
    text-align: center;
    margin: 30px;
    font-weight: normal;
}
td a {
    cursor: pointer;
}
/*tr:hover:not:nth-child(0) {*/
    /*background-color: #e6e7ff;*/
/*}*/
.data-table {
    cursor: pointer;
}
.data-table:hover {
    background-color: WhiteSmoke;
}
mat-cell:nth-child(7), mat-cell:nth-child(8), mat-cell:nth-child(9) {
   text-align: right;
}
mat-cell:nth-child(5) {
   text-align: left;
}
mat-cell:nth-child(0), mat-cell:nth-child(1), mat-cell:nth-child(2), mat-cell:nth-child(3), mat-cell:nth-child(4), mat-cell:nth-child(6) {
   text-align: center;
}
mat-row {
   cursor: pointer;
}
mat-row:hover {
   background-color: #e6e7ff;
}
mat-header-cell {
   text-align: center;
   color: black;
   font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/report/tax-report.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,eAAe;IACf,OAAO;IACP,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;GAC1B,gBAAgB;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;GACxB,qBAAqB;GACrB,gBAAgB;AACnB;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,OAAO;AACX;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,oBAAoB;IACpB,WAAW;AACf;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA,8BAA8B;IAC1B,6BAA6B;AACjC,IAAI;AACJ;IACI,eAAe;AACnB;AACA;IACI,4BAA4B;AAChC;AACA;GACG,iBAAiB;AACpB;AACA;GACG,gBAAgB;AACnB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,eAAe;AAClB;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,kBAAkB;GAClB,YAAY;GACZ,iBAAiB;AACpB","sourcesContent":[".logo img {\n    margin: 10px;\n    width: 60px;\n}\n.example-container {\n    display: flex;\n    flex-direction: column;\n    max-height: 500px;\n    background: white;\n    min-width: 300px;\n}\n\n.example-header {\n    min-height: 64px;\n    display: flex;\n    align-items: center;\n    padding-left: 24px;\n    font-size: 20px;\n}\n\n.mat-table {\n    overflow: auto;\n}\n.preview-container {\n    background-color: white;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 99;\n    overflow: auto;\n    margin-bottom: 5px;\n}\n.preview-header {\n    height: 60px;\n    padding: 0 20px 0 10px;\n    width: 100%;\n}\n.preview-header .back-button {\n    background: transparent;\n    border: none;\n    color: #d0d4d9;\n    cursor: pointer;\n    outline: none;\n    width: 32px;\n    height: 32px;\n}\n.doc-title {\n    margin: 0 15px 0 5px;\n}\n.doc-title h1 {\n    color: #fff;\n    font-size: 16px;\n    font-weight: normal;\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.doc-title-modified {\n    color: #d0d4d9;\n    font-size: 12px;\n    margin-top: 3px;\n}\n\n.file-action {\n    justify-content: flex-end;\n   margin-top: 25px;\n}\n.file-action button + button {\n    margin-left: 1em;\n}\n.file-action button.mat-button, .file-action button.mat-raised-button {\n    line-height: 28px;\n    min-width: 80px;\n    padding: 0 12px;\n    background-color: lavender;\n}\ntable {\n    font-family: arial, sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n}\n\ntd, th {\n    border: 1px solid #dddddd;\n    text-align: left;\n    padding: 8px;\n    /*white-space: nowrap;*/\n   word-wrap: break-word;\n   max-width: 200px;\n}\n\ntr:nth-child(1) {\n    background-color: #4b5049;\n    /*background-color: rgba(0, 188, 212, 0.7);*/\n    color: white;\n}\nth {\n    text-align: center;\n}\n.mat-raised-button.mat-primary, .mat-fab.mat-primary, .mat-mini-fab.mat-primary, .mat-raised-button.mat-warn{\n    /*background-color: rgba(0, 101, 201, 0.89);*/\n    margin-top: 17px;\n    min-width: 0px;\n}\n.mat-select {\n    margin-left: 15px;\n}\n.header_report {\n    width: 90%;\n    /*border: 1px solid #ddd;*/\n    border: 1px solid white;\n    background-color: white;\n    padding: 20px;\n    margin: 0 auto;\n}\n.filter {\n    margin: 70px 0px;\n}\n.filter-title {\n    /*background: #53b3ff;*/\n    /*padding: 7px 19px 7px;*/\n    padding: 0px 19px 0px;\n    color: #fff;\n    /*font-weight:bold;*/\n    text-transform: uppercase;\n    width: 90%;\n    text-align: left;\n    display: flex;\n}\n.filter-body {\n    border: 1px solid #00bcd4;\n    padding: 20px;\n    width: 90%;\n}\n.filter-menu {\n    display: flex;\n    justify-content: center;\n}\n#filter-year {\n    margin-left: 50px;\n}\n.header_report-title {\n    /*font-weight: bold;*/\n    font-weight: 500;\n    text-align: center;\n}\ntd:nth-child(5) {\n    text-align: left;\n}\ntd:nth-child(0), td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(6) {\n    text-align: center;\n}\ntd:nth-child(7), td:nth-child(8), td:nth-child(9) {\n    text-align: right;\n}\n.minimize {\n    cursor: pointer;\n}\n.filter-title p {\n    flex: 1;\n}\n.filter-title i {\n    margin-top: 15px;\n    font-size: 14px;\n    cursor: pointer;\n}\n.mat-dialog-content {\n    padding: 0px;\n}\n#report-zone {\n    margin-top: 40px;\n}\n.page-notfound-icon {\n    opacity: .7;\n    width: 300px;\n    height: 300px;\n    margin: auto;\n}\n.page-notfound {\n    text-align: center;\n    padding: 10em;\n}\n.page-notfound h1 {\n    font-weight: lighter;\n    margin: 1em;\n}\n.pagination {\n    display: inline-block;\n}\n\n.pagination a {\n    color: black;\n    float: left;\n    padding: 8px 16px;\n    text-decoration: none;\n    border: 1px solid #ddd;\n}\n\n.pagination a.active {\n    background-color: #53b3ff;\n    color: white;\n    border-radius: 5px;\n    border: 1px solid #53b3ff;\n}\n\n.pagination a:hover:not(.active) {\n    background-color: #ddd;\n    border-radius: 5px;\n}\n.div-pagination {\n    /*margin: 25px 25px;*/\n    /*margin: 25px 100px 25px 25px;*/\n    margin: 25px 0px;\n}\n.page {\n    cursor: pointer;\n}\n.size {\n    min-height: 250px;\n    align-items: start;\n}\nh3 {\n    text-align: center;\n    margin: 30px;\n    font-weight: normal;\n}\ntd a {\n    cursor: pointer;\n}\n/*tr:hover:not:nth-child(0) {*/\n    /*background-color: #e6e7ff;*/\n/*}*/\n.data-table {\n    cursor: pointer;\n}\n.data-table:hover {\n    background-color: WhiteSmoke;\n}\nmat-cell:nth-child(7), mat-cell:nth-child(8), mat-cell:nth-child(9) {\n   text-align: right;\n}\nmat-cell:nth-child(5) {\n   text-align: left;\n}\nmat-cell:nth-child(0), mat-cell:nth-child(1), mat-cell:nth-child(2), mat-cell:nth-child(3), mat-cell:nth-child(4), mat-cell:nth-child(6) {\n   text-align: center;\n}\nmat-row {\n   cursor: pointer;\n}\nmat-row:hover {\n   background-color: #e6e7ff;\n}\nmat-header-cell {\n   text-align: center;\n   color: black;\n   font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
